import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { connectRefinementList } from 'commons/react-instantsearch-dom-wrappers';
import useProductListingPageContext from 'data-hooks/useProductListingPageContext';
import ProductListingClearAllFiltersButton from '../ProductListingClearAllFiltersButton';
import ProductListingQuickshipFilter from '../ProductListingQuickshipFilter';
import DesktopProductListingListFilter from './DesktopProductListingListFilter';
import DesktopProductListingSearchFilter from './DesktopProductListingSearchFilter';
import ProductListingWidthRangeFilter from '../ProductListingWidthRangeFilter';
const DesktopProductListingSidebarFiltersUI = t0 => {
  const $ = _c(18);
  const {
    variant
  } = t0;
  const {
    filters: t1
  } = useProductListingPageContext();
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  if ($[0] !== t1 || $[1] !== variant) {
    const filters = t1 === undefined ? [] : t1;
    const filtersWithoutColors = filters.filter(_temp);
    t4 = "pb-4";
    t5 = "ProductListingSidebarFilters";
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
      t6 = <ProductListingClearAllFiltersButton />;
      $[7] = t6;
    } else {
      t6 = $[7];
    }
    t2 = "flex flex-col gap-5";
    let t7;
    if ($[8] !== variant) {
      t7 = t8 => {
        const {
          id,
          label,
          options
        } = t8;
        if (id === "search") {
          return <DesktopProductListingSearchFilter key={id} />;
        }
        if (id === "quickship") {
          return <ProductListingQuickshipFilter key={id} />;
        }
        if (id === "widthRange") {
          return <ProductListingWidthRangeFilter key={id} showTitle={true} />;
        }
        if (variant === "advanced-search" && options.length === 0) {
          return null;
        }
        return <div key={id} data-xc="ProductListingFilterGroup"><h3 className="text-base font-bold mb-2">{label}</h3><DesktopProductListingListFilter id={id} /></div>;
      };
      $[8] = variant;
      $[9] = t7;
    } else {
      t7 = $[9];
    }
    t3 = filtersWithoutColors.map(t7);
    $[0] = t1;
    $[1] = variant;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
    $[5] = t5;
    $[6] = t6;
  } else {
    t2 = $[2];
    t3 = $[3];
    t4 = $[4];
    t5 = $[5];
    t6 = $[6];
  }
  let t7;
  if ($[10] !== t2 || $[11] !== t3) {
    t7 = <div className={t2}>{t3}</div>;
    $[10] = t2;
    $[11] = t3;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t4 || $[14] !== t5 || $[15] !== t6 || $[16] !== t7) {
    t8 = <div className={t4} data-xc={t5}>{t6}{t7}</div>;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  return t8;
};
const AlgoliaProductFiltersDesktop = connectRefinementList(DesktopProductListingSidebarFiltersUI);
AlgoliaProductFiltersDesktop.displayName = 'AlgoliaProductFiltersDesktop';
const DesktopProductListingSidebarFilters = t0 => {
  const $ = _c(2);
  const {
    variant
  } = t0;
  let t1;
  if ($[0] !== variant) {
    t1 = variant === "advanced-search" ? <AlgoliaProductFiltersDesktop attribute="type" facetOrdering={true} limit={500} variant={variant} /> : <DesktopProductListingSidebarFiltersUI />;
    $[0] = variant;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
export default DesktopProductListingSidebarFilters;
function _temp(filter) {
  return filter.id !== "color";
}